<div class="avatar"><i class="uil uil-user"></i></div>